<template>
  <div class="add-plan-body">
    <!-- 如果要加回显就把addTarget换成props.target,需让后端
      把接口system/selectUserList多传typeId和roleId -->
    <EditCom
      :target="addTarget"
      :inputList="addInputList"
      :buttonList="addButtonList"
      :rules="addRules"
      :title="props.title"
      @closeFun="closeAdd"
      ref="edit_com"
    />
  </div>
</template>

<script setup>
import {
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive
} from 'vue';
import EditCom from '@/components/EditCom/index.vue'
import { putMap } from '@/api/MapManage/index'
import { message } from '@/utils/js/initVariable'
import { dayjs } from  '@/utils/js/initVariable';

const props = defineProps({
  target: {
    type: Object,
    default: () => ({})
  },
  title: {
    type: String,
    default: () => ({})
  }
})

const closeAdd = ()=>{
  emit('close')
}
const layerTypeList = ref([
    { layerTypeId: '侦察足迹', layerTypeName: '侦察足迹' }
])
const layerModeList = ref([
    { layerModeId: 'Gwc', layerModeName: 'Gwc' }
])
const timeTypeList = ref([
  { timeTypeId: 4, timeTypeName: '年' },
  { timeTypeId: 3, timeTypeName: '季度' },
  { timeTypeId: 2, timeTypeName: '月' },
  { timeTypeId: 1, timeTypeName: '周' }
])

const addSubmit = (form, target, button, loadFn) => {
  form.value.validate((valid) => {
    if (valid) {
      // 构造请求参数（只保留图层相关字段）
      const params = {
        layerName: target.layerName,
        layerType: target.layerType,
        layerCoordinate: target.layerCoordinate,
        layerZoomMin: target.layerZoomMin,
        layerZoomMax: target.layerZoomMax,
        layerMode: target.layerMode,
        layerUrl: target.layerUrl,
        timeType: target.timeType,
        layerDataStartDate: target.layerDataStartDate 
          ? dayjs(target.layerDataStartDate).format('YYYY-MM-DD HH:mm:ss')
          : null,
        layerDataEndDate: target.layerDataEndDate
          ? dayjs(target.layerDataEndDate).format('YYYY-MM-DD HH:mm:ss')
          : null
      }
      if (target.id) {
        params.id = target.id
      }
      putMap(params).then((res) => {
        if (res.data.code === 1004) {
          message(`${props.title}成功`, 1)
          closeAdd()
          emit('refresh')
        } else {
          message(res.data.msg || '操作失败', 0)
        }
      }).catch((err) => {
        console.error(err)
        message('请求失败', 0)
      }).finally(() => {
        loadFn() 
      })
    } else {
      loadFn() 
    }
  })
}
// 组件EditCom
const addTarget = reactive({
  ...props.target,
  layerTypeList: layerTypeList.value,
  layerModeList: layerModeList.value,
  timeTypeList: timeTypeList.value, 
})
const addInputList = ref([]),
      addButtonList = ref([
        { name: '取消', fun: closeAdd, type: 'danger', },
        { name: '确定', fun: addSubmit, type: 'primary', },
      ]),
      addRules = reactive({})
const form = ref({
  userName: '',
  pwd: '',
  tel: '',
  typeId: '',
  roleId: '',
  effectiveTime: ''
})

const formRef = ref(null)

const eventTypes = ref([])

const emit = defineEmits(['close', 'confirm', 'refresh'])

const editFlag = ref(false)

const close = () => {
  emit('close')
}

const getinputList = () => {
    addInputList.value = [
      { name: '图层名', prop: 'layerName', type: 'input',
        // message: { text:'请输入图层名，格式：快照:图层名，如 basemap:basemap25060915'}
      },
      {
        name: '图层类型', prop: 'layerType', type: 'select', select: {
          list: 'layerTypeList',
          key: 'layerTypeId',
          label: 'layerTypeName',
          value: 'layerTypeId'
        }
      },
      { name: '坐标系', prop: 'layerCoordinate', type: 'input' },
      { name: '最小缩放等级', prop: 'layerZoomMin', type: 'input', attrs: {type: 'number' }},
      { name: '最大缩放等级', prop: 'layerZoomMax', type: 'input' ,attrs: {type: 'number' }},
      {
        name: '发布模式', prop: 'layerMode', type: 'select', select: {
          list: 'layerModeList',
          key: 'layerModeId',
          label: 'layerModeName',
          value: 'layerModeId'
        }
      },
      // { name: '图层URL', prop: 'layerUrl', type: 'input' ,message: { text:'请输入url：格式参照:http://119.8.52.11:8123/geoserver/gwc/demo/basemap:basemap25060915?gridSet=EPSG:3857&format=image/png'}},
      {
        name: '发布时间类型', prop: 'timeType', type: 'select', select: {
          list: 'timeTypeList',
          key: 'timeTypeId',
          label: 'timeTypeName',
          value: 'timeTypeId'
        }
      },
      { name: '图层涉及数据开始日期', prop: 'layerDataStartDate', type: 'datetime', date: {} },
      { name: '图层涉及数据结束日期', prop: 'layerDataEndDate', type: 'datetime', date: {} },

    ]
    addRules.layerName = [
      { required: true, trigger: 'blur' },
    ]
    // addRules.year = [
    //   { required: true, message: '请输入年份', trigger: 'blur' },
    // ]
    // addRules.quarter = [
    //   { required: true, message: '请输入季度', trigger: 'blur' }
    // ]
    // addRules.month = [
    //   { required: true, message: '请输入月份', trigger: 'blur' }
    // ]
    // addRules.week = [
    //   { required: true, message: '请输入第几周', trigger: 'blur' }
    // ]
    // addRules.startDate = [
    //   { required: true, message: '请选择开始时间', trigger: 'change' }
    // ]
    // addRules.endDate = [
    //   { required: true, message: '请选择结束时间', trigger: 'change' }
    // ]
    addRules.layerUrl = [
      { required: true, trigger: 'blur' }
    ]
  }

onMounted(() => {
//   fetchType()
//   fetchRole()
  getinputList()
})
</script>

<style lang="less" scoped>
.add-plan-body {
  z-index: 2;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}

.additional-info {
  margin-top: 16px;
}
</style>